/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-11 17:20:02
 * @LastEditors: K
 * @LastEditTime: 2022-09-26 14:17:00
 */
import {Button, Col, Modal, Row, Space, Checkbox, notification, Input,Form} from 'antd';
import React, { useState } from 'react';
import { PurchaseModal } from '../../compnents/importModal/purchaseModal';
import { NavBar } from '../../compnents/nav/NavBar';
import styles from "./dataImportPage.module.css";
import {
  goTenantDataInitDoAsync,
  tenantDataInitAsync,
  tenantDataSendSmsAsync,
  YunDiMaterialImportExcelAsync
} from "../../compnents/importModal/purchaseModalSlice";
import {unwrapResult} from "@reduxjs/toolkit";
import { useDispatch } from "react-redux"
import {RootDispatch} from "../../app/store";
import {getJurisdiction} from "../versionManagement/versionManagementSlice";
import {setSmsCountdown} from "../login/loglinSlice";
import {SearchOutlined} from "@ant-design/icons";

export const DataImportPage = () => {
  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false)  // 控制导入弹窗是否显示

  const tenantId = location.search.replace('?', '')   //表格数据 ID
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  let smsCode = "";

  const dispatch = useDispatch<RootDispatch>()

  const [purchaseModalState, setPurchaseModalState] = useState<number>()   //模板弹窗导入模板控制
  const [checkedItems, setCheckedItems] = useState<string[]>([]);

  const options = [
    { label: '删除药品目录', value: '1' },
    { label: '删除诊疗目录', value: '2' },
    { label: '删除库存单据', value: '3' },
    { label: '删除库存台账', value: '4' },
    { label: '删除结算记录', value: '5' },
    { label: '删除病历记录', value: '6' },
    { label: '删除患者记录', value: '7' },

  ];
  const importTemplateFn = (state: number) => {   // 导入模板
    setPurchaseModalState(state)
    setIsPurchaseModalVisible(true)
  }
  // 复选框变化事件
  const handleCheckboxChange = (checkedValues:any) => {
    setCheckedItems(checkedValues);
  };
  // 取消按钮事件
  const handleCancel = () => {
    setModalVisible(false);
    // 清空选中状态（可选）
    setCheckedItems([]);
  };
  // 确定按钮事件
  const handleConfirm = () => {
    setLoading(true)
    if(!tenantId){
      notification.error({
        message: "所选机构不正确",
        duration: 3,
      });
    }
    console.log('选中的项目:', checkedItems);
    // 构建参数对象
    const params: {
      tenantId: number;
      materialsCatalog?: boolean; //药品目录
      treatmentCatalog?: boolean; //诊疗目录
      inventoryReceipts?: boolean; //库存单据
      inventoryLedger?: boolean; //库存台账
      payment?: boolean; //结算记录
      treatment?: boolean ; //病历信息
      patient?: boolean; //患者信息
      code?:string;//验证码
    } = {
      tenantId: Number(tenantId)
    };

    // 根据勾选项设置参数
    if (checkedItems.includes('1')) {
      params.materialsCatalog = true;
    }

    if (checkedItems.includes('2')) {
      params.treatmentCatalog = true;
    }

    if (checkedItems.includes('3')) {
      params.inventoryReceipts = true;
    }

    if (checkedItems.includes('4')) {
      params.inventoryLedger = true;
    }

    if (checkedItems.includes('5')) {
      params.payment = true;
    }

    if (checkedItems.includes('6')) {
      params.treatment = true;
    }

    if (checkedItems.includes('7')) {
      params.patient = true;
    }

    dispatch(tenantDataInitAsync(params))
      .then(unwrapResult)
      .then((t: any) => {
        if(!t){
          notification.error({
            message: "没有需要处理的数据",
            duration: 3,
          });
        }else{
          Modal.confirm({
            centered: true,
            title: '请确认',
            content: <div><p>{t}</p><p style={{"color":"red"}}>此操作较为敏感，请仔细确认。</p></div>,
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: () => {
              verifySmsCode(params);
            },
          })
        }
      }).catch((e)=>{
        setModalVisible(false);
        // 清空选中状态（可选）
        setCheckedItems([]);
      }).finally(()=>{
        setLoading(false)
      })

    console.log(params);
    // 关闭模态框
    //setModalVisible(false);
    // 清空选中状态（可选）
    // setCheckedItems([]);
  };

  const verifySmsCode = (params : any) =>{
    setLoading(true);
    dispatch(tenantDataSendSmsAsync(params))
      .then(unwrapResult)
      .then((t: any) => {
        //TODO
        if(!t){
          notification.error({
            message: "没有需要处理的数据",
            duration: 3,
          });
        }else{
          Modal.confirm({
            centered: true,
            title: '请确认',
            content: <div><p>{t}</p><p style={{"color":"red"}}>此操作较为敏感，请输入发往管理员的短信验证码。</p>
              <Input
                onChange={(e) =>{
                  smsCode = e.target.value
                }}
              placeholder="请输入短信验证码"
              allowClear
              /></div>,
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: () => {
              goInit(params,smsCode)
              smsCode = "";
            },
          })
        }

      }).catch((e)=>{
        setModalVisible(false);
        // 清空选中状态（可选）
        setCheckedItems([]);
      }).finally(()=>{
        setLoading(false)
      })
  }
  const goInit = (params : any,smsCode:string) =>{
    setLoading(true)
    dispatch(goTenantDataInitDoAsync({...params,code:smsCode}))
      .then(unwrapResult)
      .then((t: any) => {
        setLoading(false)
        if(t){
          notification.success({
            message: "执行完毕",
            duration: 3,
          });
        }
      }).catch((e)=>{
        setModalVisible(false);
        // 清空选中状态（可选）
        setCheckedItems([]);
      }).finally(()=>{
        setLoading(false)
      })
  }
  return (
    <>
      <NavBar
        style={{ margin: '10px 20px' }}
        where={['机构管理', '数据导入']}
        backtrace={{
          name: '机构管理',
          path: '/admin/tenant',
        }}
      />
      <div className={styles.wrap}>
        <Row style={{ padding: '10px' }}>
          <Space style={{ alignItems: 'normal' }}>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(1)}>患者导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(2)}>患者诊断信息导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(3)}>收费信息导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(4)}>牙医管家诊断模板导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(8)}>云迪药品导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(9)}>云迪诊疗项目导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(10)}>云迪材料导入</Button>
            </Col>
            <Col>
              <Button type='primary' onClick={() => importTemplateFn(11)}>云迪库存导入</Button>
            </Col>
            <Col>
              <Button type='primary' danger loading={loading} onClick={() => {
                setModalVisible(true);
              }}>数据初始化</Button>
            </Col>

          </Space>
      </Row>
      </div>
      <Modal
        title="请选择要删除的内容"
        visible={modalVisible}
        onCancel={handleCancel}
        footer={null}
        width={400}
      >
        <Checkbox.Group
          options={options}
          value={checkedItems}
          onChange={handleCheckboxChange}
          style={{ width: '100%' }}
        />
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            取消
          </Button>
          <Button type="primary" onClick={handleConfirm} loading={loading}>
            确定
          </Button>
        </div>
      </Modal>
      <PurchaseModal

        id={tenantId}
        state={purchaseModalState}
        isPurchaseModalVisible={isPurchaseModalVisible}
        onOk={() => {
          setIsPurchaseModalVisible(false)
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
        }}
      />
    </>
  );
}

